//export const baseURL = "https://api.d7ksuper.com/api/"; //CANLI panel.d7k

export const baseURL = "https://dev-api.d7ksuper.com/api/"; //TEST dev-panel.d7k
export const plcHubUrl = "https://plcreaderapi.d7ksuper.com/plchub";
export const fileURL = "https://storage.d7ksuper.com/api/";
export const fileSignalR = "https://storage.d7ksuper.com/";
export const fileWithProgress = "https://storage.d7ksuper.com/api/files/";
export const discordApi = "https://dcbotapi.d7ksuper.com/api/Report/";

let signalRUrl;

switch (window.location.hostname) {
  case "dev-panel.d7ksuper.com":
    signalRUrl = "https://communication.d7ksuper.com/stage-sgnl/";

    break;
  case "panel.d7ksuper.com":
    signalRUrl = "https://communication.d7ksuper.com/sgnl/"; // Prod URL eklenebilir
    break;
  case "b2b.ucantay.com":
    signalRUrl = "https://communication.d7ksuper.com/sgnl/";
    break;
  default:
    signalRUrl = "https://communication.d7ksuper.com/dev-sgnl/"; // Varsayılan bir URL belirleyin
}

export { signalRUrl };
